<template>
    <el-drawer
        title="上传图片"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"                
                ref="formData"
                :rules="rules"
            >				
                <el-form-item prop="pic1" :label="currentName + '选中图'" required>
					<div class="form-flex">
						<image-upload 
                            :url.sync="formData.pic1" 
                            :urlFull.sync="formData.pic1" 
                        >
                        </image-upload>
					</div>				    
				</el-form-item>
				<el-form-item prop="pic2"  :label="currentName + '未选中图'"  required>
					<div class="form-flex">
						<image-upload 
                            :url.sync="formData.pic2" 
                            :urlFull.sync="formData.pic2" 
                        >
                        </image-upload>
					</div>				    
				</el-form-item>
				<el-form-item prop="pic3" :label="currentName + '列表图'" required>
					<div class="form-flex">
						<image-upload 
                            :url.sync="formData.pic3" 
                            :urlFull.sync="formData.pic3" 
                        >
                        </image-upload>
					</div>				    
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" 
				:loading="btnLoading"
				@click="submitForm"
             >提交</el-button
            >
        </div> 
    </el-drawer>
</template>

<script>

import ImageUpload from '@/components/ImageUpload';

const defaultFormData = {
    pic1: '',
    pic2: '',
    pic3: '',
}

export default {
    components: { ImageUpload },
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading: false,
            formData: {
                ...defaultFormData
            },
			currentName:'',
            currentIndex: null, // 当前编辑的分类索引
            currentData: null,   // 当前的 typeSort 数据引用
            rules: {
                pic1: [
                    { required: true, message: '请上传图片1', trigger: 'change' }
                ],
                pic2: [
                    { required: true, message: '请上传图片2', trigger: 'change' }
                ],
                pic3: [
                    { required: true, message: '请上传图片3', trigger: 'change' }
                ]
            }
        }
    },
    
    methods: {
        close() {            
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.formData = { ...defaultFormData };
            this.currentIndex = null;
            this.currentData = null;
            this.drawerShow = false;
        },
        
        show(data,name, index) {			
            this.currentData = data;
            this.currentIndex = index;
            this.currentName = name;
			console.log(this.currentName)
            // 回显已有的图片数据
            if (data && index !== undefined && data[index]) {
                this.formData = {
                    pic1: data[index].pic1 || '',
                    pic2: data[index].pic2 || '',
                    pic3: data[index].pic3 || ''
                };
            } else {
                this.formData = { ...defaultFormData };
            }
            
            this.drawerShow = true;
        },
        
        // 表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    // 更新 typeSort 中对应索引的图片数据
                    if (this.currentData && this.currentIndex !== null) {
                        this.$set(this.currentData, this.currentIndex, {
                            ...this.currentData[this.currentIndex],
                            pic1: this.formData.pic1,
                            pic2: this.formData.pic2,
                            pic3: this.formData.pic3
                        });
                    }
                    this.$message.success('图片上传成功');
                    this.close();
                } else {
                    this.$message.error('请上传全部三张图片');
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.form-flex {
    width: 100%;
    overflow: hidden;
}

.drawer-content {
    padding: 20px;
    min-width: 400px;
}

.drawer-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px 20px;
    border-top: 1px solid #e4e7ed;
    text-align: right;
    width: 100%;
    background: #fff;
}
</style>